export { ElectricNamespace, electrify } from './electric'
export type { ElectrifyOptions } from './electric'
export type { ElectricConfig } from './config'
